"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNewRevision = void 0;
var isNewRevision = function (revision) { return !revision.from; };
exports.isNewRevision = isNewRevision;
//# sourceMappingURL=revisions.js.map